module.exports = __webpack_public_path__ + "static/media/medical center heading.e5b3a9c3.svg";